import * as Icons from './components'
import Icon from './icon'

export { Icons }
export default Icon
